export const toggleView = () => {

  const btnToggleView = document.querySelectorAll(".js-view-toggle");
  const view = document.querySelectorAll(".js-view");

  const init = () => {
    bind();
  };

  const bind = () => {
    btnToggleView.forEach((btn) => {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        btnToggleView.forEach((btn) => {
          btn.classList.remove("is-active");
        });
        this.classList.add("is-active");
        let viewToToggle = this.getAttribute("data-view");
        view.forEach((v) => {
          v.classList.add("u-hidden");
        });
        document
          .querySelectorAll(`[data-view="${viewToToggle}"]`)
          .forEach((v) => { v.classList.remove("u-hidden");
        });
        document.body.setAttribute("data-current-view", viewToToggle);
        const scrollToElement = (element) => {
          element.scrollIntoView({ behavior: "smooth" });
        };
        if(viewToToggle === "about") {
          scrollToElement(document.querySelector(".c-logo-part--s"));
        }
      });
    });
  };

  init();

};

